import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';

@IonicPage()
@Component({
  selector: 'page-project',
  templateUrl: 'project.html',
})
export class ProjectPage {
  private projects = [];
  private work: any;
  private tasks = [];
  private desc: any;
  private title: any;
  config1: any;
  private spendTime = 0;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {

      this.config1 = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.projects.length
      };
  }
  pageChanged(event){
    this.config1.currentPage = event;
  }
  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Прожектууд';
    this.getProject();
  }

  getProject(){
    this.spendTime = 0;
    this.rest.GetWorks(this.data.companyId, null, null).subscribe(res => {
      this.projects = res;
      //const a = res.total_spend_time;
      //console.log(a);
    });
  }

  closeProject(work: any){
    if(confirm('Та тухайн прожектыг хаахдаа итгэлтэй байна уу?')) {
      this.rest.addProject(work.id, this.data.companyId, "1", work.title, work.begin_day, work.end_day, work.usage_time, "", "", work.customer_id, work.member_ids, this.data.userId, "1").subscribe(res => {
       this.showToast('Таны сонгосон Прожект амжилттай хаагдлаа.');
        this.getProject();
      });
    }
  }

  addProject(work: any){
    let addProject = this.modalCtrl.create(
      ModalAddProjectPage,
      { work: work },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    addProject.present().catch(err => {

    });
    addProject.onDidDismiss((data) => {
      if(data != null) {
        this.getProject();
      }
    });
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}
  @Component({
    template: `
    <ion-header text-center style="height: 50px; background-color: #84dac8;">
      <ion-title>Прожект</ion-title>
    </ion-header>
    <ion-content text-center>
      <ion-grid>

          <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
           <ion-list radio-group>
           <ion-item>
                  <ion-label>Прожект хариуцагч</ion-label>
                  <ion-select name="leader" [(ngModel)]="leaderUserId" (ionChange)="getCmbUser($event)">
                     <ion-option *ngFor="let leader of GetCmbUser" value="{{leader.id}}">{{leader.firstname}}</ion-option>
                  </ion-select>
           </ion-item>
           </ion-list>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
          </ion-row>

  <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item >
            <ion-label floating >Прожектийн нэр</ion-label>
            <ion-textarea [(ngModel)]="title"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>

  <ion-row>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
    <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
      <ion-item>
        <ion-label>Эхлэх хугацаа</ion-label>
        <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="beginDay"></ion-datetime>
    </ion-item>
    </ion-col>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
    <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
      <ion-item>
        <ion-label>Дуусах хугацаа</ion-label>
        <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="endDay"></ion-datetime>
    </ion-item>
    </ion-col>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
  </ion-row>

  <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
            <ion-label floating>Зарцуулах цаг</ion-label>
            <ion-textarea [(ngModel)]="usageTime"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>

  <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <ion-label>Харилцагч компани</ion-label>
            <ion-select name="customer" [(ngModel)]="customerId" (ionChange)="getCustomers($event)" style="width: 100%;text-transform: uppercase;">
              <ion-option *ngFor="let customer of GetCustomers" value="{{customer.id}}">{{customer.customer_name}}</ion-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
  </ion-row>



  <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <ion-label>Оролцогчид</ion-label>
          <ion-select multiple="true" name="spendPerson" [(ngModel)]="projectMembersIds" (ionChange)="getCmbUser($event)">
              <ion-option *ngFor="let spendPerson of GetCmbUser" value="{{spendPerson.id}}">{{spendPerson.firstname}}</ion-option>
          </ion-select>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
  </ion-row>


  <ion-row>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
    <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
      <ion-item>
        <button full class="myButton" (click)="createProject()" *ngIf="work == null">Үүсгэх</button>
        <button full class="myButton" (click)="settingProject()" *ngIf="work != null">Засах</button>
      </ion-item>
    </ion-col>
    <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
      <ion-item>
        <button full class="myButton" (click)="backto()">Буцах</button>
      </ion-item>
    </ion-col>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
  </ion-row>
  </ion-grid>
  </ion-content>
    `
  })

  export class  ModalAddProjectPage {
    private workId: any;
    private companyId: any;
    private leaderUserId: any;
    private title: any;
    private beginDay: any;
    private endDay: any;
    private usageTime: any;
    private spendTime: any;
    private spendProcess: any;
    private createdUserId: any;
    private customerId: any;
    private projectMembersIds: any;
    private userId: any;
    private GetCmbUser = [];
    private GetCustomers = [];
    private addProject: any;
    private projectMembersId = '';
    private work: any;
    constructor(public navCtrl: NavController,
      public navParams: NavParams,
      public alertCtrl: AlertController,
      private rest: RestProvider,
      public httpClient: HttpClient,
      private viewCtrl: ViewController,
      private toastCtrl: ToastController,
      private data: DataProvider,){
        this.work = this.navParams.get('work');
        if(this.work != null) {
          this.leaderUserId = this.work.created_user_id;
          this.title = this.work.title;
          this.beginDay = this.work.begin_day;
          this.endDay = this.work.end_day;
          this.usageTime = this.work.usage_time;
          this.customerId = this.work.customer_id;
          this.projectMembersIds = this.work.member_ids.split(',');
        }
        this.rest.GetCmbUser(this.data.companyId).subscribe(res => {
          this.GetCmbUser = res;
          });
        this.rest.GetCustomers().subscribe(res => {
          this.GetCustomers = res;
          });
    }

    getCmbUser($event){}

    getCustomers($event){}

    createProject(){
      this.projectMembersId = '';
      if( !this.leaderUserId ){
        this.leaderUserId == null;
        this.showToast1('Хариуцагч сонгогдоогүй байна!!!');
        return;
      }
      if( !this.title ){
        this.title == null;
        this.showToast1('Прожектийн нэр бичигдээгүй байна!!!');
        return;
      }
      if( !this.beginDay ){
        this.beginDay == null;
        this.showToast1('Прожект эхлэх өдөр сонгогдоогүй байна!!!');
        return;
      }
      if( !this.endDay ){
        this.endDay == null;
        this.showToast1('Прожект дуусах өдөр сонгогдоогүй байна!!!');
        return;
      }
      if( !this.usageTime ){
        this.usageTime == null;
        this.showToast1('Прожектийн зарцуулалтын цаг бичигдээгүй байна!!!');
        return;
      }
      if( !this.customerId ){
        this.customerId == null;
        this.showToast1('Харилцагч компани сонгогдоогүй байна!!!');
        return;
      }
      for(let i = 0; i < this.projectMembersIds.length;i++){
        this.projectMembersId = this.projectMembersId + this.projectMembersIds[i].toString();
        if(i < (this.projectMembersIds.length) - 1) {
          this.projectMembersId = this.projectMembersId + ',';
        }
      }
      this.rest.addProject("", this.data.companyId, this.leaderUserId, this.title, this.beginDay, this.endDay, this.usageTime, "", "", this.customerId, this.projectMembersId, this.data.userId, "").subscribe(res => {
        this.addProject = res;
        if(res.msg == null) {
          this.showToast1('Та прожектийн мэдээллээ бүрэн оруулна уу.');
        } else if(res.msg == 'ok') {
          this.showToast('Прожект амжилттай үүслээ.');
          this.viewCtrl.dismiss({data: 'edit'});
        } else {
          this.showToast('Бүртгэлтэй Прожект байна.');
        }
      });
    }

    settingProject(){
      this.projectMembersId = '';
      if( !this.leaderUserId ){
        this.leaderUserId == null;
        this.showToast1('Хариуцагч сонгогдоогүй байна!!!');
        return;
      }
      if( !this.title ){
        this.title == null;
        this.showToast1('Прожектийн нэр бичигдээгүй байна!!!');
        return;
      }
      if( !this.beginDay ){
        this.beginDay == null;
        this.showToast1('Прожект эхлэх өдөр сонгогдоогүй байна!!!');
        return;
      }
      if( !this.endDay ){
        this.endDay == null;
        this.showToast1('Прожект дуусах өдөр сонгогдоогүй байна!!!');
        return;
      }
      if( !this.usageTime ){
        this.usageTime == null;
        this.showToast1('Прожектийн зарцуулалтын цаг бичигдээгүй байна!!!');
        return;
      }
      if( !this.customerId ){
        this.customerId == null;
        this.showToast1('Харилцагч компани сонгогдоогүй байна!!!');
        return;
      }
      for(let i = 0; i < this.projectMembersIds.length;i++){
        this.projectMembersId = this.projectMembersId + this.projectMembersIds[i].toString();
        if(i < (this.projectMembersIds.length) - 1) {
          this.projectMembersId = this.projectMembersId + ',';
        }
      }
      this.rest.addProject(this.work.id, this.data.companyId, this.leaderUserId, this.title, this.beginDay, this.endDay, this.usageTime, "", "", this.customerId, this.projectMembersId, this.data.userId, "").subscribe(res => {
        this.addProject = res;
        if(res.msg == null) {
          this.showToast1('Та прожектийн мэдээллээ бүрэн оруулна уу.');
        } else if(res.msg == 'ok') {
          this.showToast('Прожект амжилттай засагдлаа.');
          this.viewCtrl.dismiss({data: 'edit'});
        } else {

        }
      });
    }

    backto(){
      this.viewCtrl.dismiss({});
    }

    showToast(str: any) {
      let toast = this.toastCtrl.create({
        message: str,
        position: 'middle',
        duration: 5000,
        cssClass: "toast-success"
      });
      toast.present();
    }
    showToast1(str: any) {
      let toast = this.toastCtrl.create({
        message: str,
        position: 'middle',
        duration: 5000,
        cssClass: "toast-unsuccess"
      });
      toast.present();
    }
  }



// WEBPACK FOOTER //
// ./src/pages/project/project.ts